import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {SellerPercentageData} from '../../../../shared/models/seller-percentages.model';
import {PercentService} from '../../../../shared/services/percent/percent.service';
import {RouteUtils} from "../../../../utils/route.utils";
import {StatusService} from "../../../../shared/services/authentication/status.service";
import {AnalyticsService} from '../../../../shared/services/analytics/analytics.service';
import {EventEnum, PathUrlEnum} from '../../../../utils/analytics.utils';
import {roundIfMoreThan2Decimals} from "../../../../utils/roundIfMoreThan2Decimals.utils";

@Component({
  selector: 'app-property-division-form',
  templateUrl: './property-division-form.component.html',
  styleUrls: ['./property-division-form.component.scss'],
})
export class PropertyDivisionFormComponent implements OnInit {
  @Input() cnpjSeller: boolean = false;
  sellerPercentageData: SellerPercentageData;
  isLoadingData: boolean = false;
  btnLoading = false;
  showError: boolean = false;
  errorCount: number = 0;
  isButtonDisabled: boolean = true;

  constructor(
    private router: Router,
    private PercentService: PercentService,
    private statusService: StatusService,
    private analyticsService: AnalyticsService,
  ) {
  }

  ngOnInit() {
    this.analyticsService.track(PathUrlEnum.PROPRIETARIO_DIVISAO_IMOVEL);
    this.getSellerPercentageData();
    this.checkButtonState();
  }

  backStep() {
    this.analyticsService.trackEvent(PathUrlEnum.PROPRIETARIO_DIVISAO_IMOVEL, EventEnum.BTN_VOLTAR);
    this.router.navigateByUrl('forms-list');
  }

  checkButtonState() {
    const allSellersFilled = this.sellerPercentageData?.otherSellers.every(seller => seller.isFilled);
    const anyAccountFilled = this.sellerPercentageData?.accounts.some(account => typeof (account.percentage) === "number");


    const totalSellersPercentage = roundIfMoreThan2Decimals(this.sellerPercentageData?.otherSellers.reduce((sum, seller) => {
      let total: any = seller.percentage;


      if (seller.additional && seller.additional.length > 0) {
        total += seller.additional.reduce((acc, additional) => additional.percentage ? acc + additional.percentage : 0, 0);
      }

      return sum + total;
    }, 0) || 0);

    const totalAccountsPercentage = roundIfMoreThan2Decimals(this.sellerPercentageData?.accounts.reduce((sum, account) => sum + (account.percentage || 0), 0) || 0);
    const totalPercentage = roundIfMoreThan2Decimals(totalSellersPercentage + totalAccountsPercentage);

    // Lógica de habilitação do botão
    if (totalPercentage > 100) {
      // Se a soma total de percentage for maior que 100, desabilita o botão
      this.isButtonDisabled = true;
    } else if (!allSellersFilled) {
      // Se nem todos os sellers estão preenchidos, habilita o botão
      this.isButtonDisabled = false;
    } else if (allSellersFilled && !anyAccountFilled) {
      // Se todos os sellers estão preenchidos, mas nenhum account está preenchido, desabilita o botão
      this.isButtonDisabled = true;
    } else if (this.sellerPercentageData?.accounts.length > 0 && totalPercentage < 100) {
      // Se houver contas e a soma das porcentagens das contas não for 100%, desabilita o botão
      this.isButtonDisabled = true;
    } else {
      // Se nenhum dos casos anteriores se aplicou, habilita o botão
      this.isButtonDisabled = false;
    }
  }

  updateButtonState() {
    this.checkButtonState();
  }

  getSellerPercentageData() {
    this.isLoadingData = true;
    this.showError = false;
    this.PercentService.getSellersPercentages().subscribe({
      next: (response: any) => {
        this.sellerPercentageData = response;
        this.checkButtonState();
        this.isLoadingData = false;
      },
      error: () => {
        this.showError = true;
        this.errorCount++;
        this.isLoadingData = false;
      }
    });
  }

  reciverTryAgain() {
    this.errorCount++;
    this.showError = false;
    this.getSellerPercentageData();
  }

  savePercentageSeller() {
    this.analyticsService.trackEvent(PathUrlEnum.PROPRIETARIO_DIVISAO_IMOVEL, EventEnum.BTN_SALVAR_FORMULARIO);
    const accounts = this.sellerPercentageData.accounts;
    const resultArray = accounts.map(account => ({
      customerId: account.customerId,
      percentage: account.percentage
    }));

    this.btnLoading = true;
    this.PercentService.putSellersPercentages(resultArray).subscribe({
      next: () => {
        this.btnLoading = false;
        this.statusService.showToast('success', 'formulário de divisão do imóvel salvo');
        this.router.navigate([RouteUtils.PAGES.FORM_LIST]);
      },
      error: () => {
        this.btnLoading = false;
        this.showError = true;
        this.errorCount++;
      },
    });
  }
}
